<mat-paginator
	[pageSizeOptions]="[10, 25, 100]"
	(page)="stateService.pageChanged($event)"
	[pageSize]="stateService.currentPageSize()"
	[length]="stateService.totalElements()"
	[pageIndex]="stateService.currentPageIndex()"
	showFirstLastButtons="true"
/>
